import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c81191f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail_num" }, "题目：", -1))
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "answer_box" }

import { ref } from 'vue';
import { DetailsForm } from '../type';

interface IPorp {
  modelValue: DetailsForm[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsModal',
  props: {
    modelValue: null
  },
  setup(__props: any) {

const props = __props as {
  modelValue: DetailsForm[];
};



const letters = ref<string[]>([]);
for (let i = 0; i < 26; i++) {
  letters.value.push(String.fromCharCode(65 + i));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.modelValue, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "detail",
        key: index
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", null, _toDisplayString(item.title), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.answerArr, (i, j) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "answer_item",
                key: j
              }, [
                _createElementVNode("strong", null, _toDisplayString(letters.value[j]), 1),
                _createTextVNode(".   "),
                _createElementVNode("span", null, _toDisplayString(i.answer), 1)
              ]))
            }), 128))
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})